import React from 'react';
import BlogPost from '../components/BlogPost/blogPost';
import NoPost from '../components/BlogPost/noPost';
import LoadingSpinner from '../components/Loader/LoadingSpinner';
import { useGetBlogPostQuery } from '../reactWrapper/Redux/apiSlice'


const MyPost =()=>{
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetBlogPostQuery()

    if(isLoading){
        return(
            <LoadingSpinner />
        )
    }
    if(data.length === 0){
        return(
            <div className='mx-auto max-w-7xl'>
                <NoPost />
            </div>
        )
    } else if (isSuccess) {
        return(
            <div className='mx-auto max-w-7xl space-y-6'>
                <BlogPost blogItems = {data} />
            </div>
        )
    } else if (isError) {
        <div className='flex items-start gap-2 rounded-lg bg-red-50 p-3 text-xs text-red-800'>{error.toString()}</div>
    }
}

export default MyPost;
